import { observer, inject } from "mobx-react";
import * as React from "react";
import "./style.scss";

// Components
import { default as MDialog } from "@material-ui/core/Dialog";
import { default as MDialogContent } from "@material-ui/core/DialogContent";
import { default as TextField } from "@material-ui/core/TextField";
import { default as MDialogTitle } from "@material-ui/core/DialogTitle";
import { default as MDialogActions } from "@material-ui/core/DialogActions";
import { default as Button } from "@material-ui/core/Button";

// Stores
import HotelStore from "../../../../../../stores/HotelStore";

// Resources
import strings from "../../../../../../resources/strings";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class MetaTagDialog extends React.Component<IProps> {

	public render() {
		const { hotelStore } = this.props;

		return (
			<MDialog
				open={hotelStore.metaTagDialogOpen}
			>
				<MDialogTitle className="metaTagDialogTitle">{hotelStore.metaTagDialogTitle}</MDialogTitle>
				<MDialogContent className="metaTagDialogContent" >
					<TextField
						type="name"
						name="selectedMetaTag"
						label={strings.hotel.edit.fields.metaTag}
						value={hotelStore.selectedMetaTag}
						disabled={hotelStore.loading}
						onChange={hotelStore.handleValueChange}
						variant="outlined"
						className="metaTagDialogTextField"
						required={true}
					/>
				</MDialogContent>
				<div className="buttonsContainer">
					<Button
						onClick={hotelStore.addMetaTag}
						variant="contained"
						style={{ color: "white" }}
					>
						{strings.hotel.edit.buttons.save}
					</Button>
					<Button onClick={hotelStore.closeMetaTagDialog}>
						{strings.hotel.edit.buttons.exit}
					</Button>
				</div>
			</MDialog>
		);
	}
}
